import React from 'react';
export interface InformationPanelProps {
  children: JSX.Element | JSX.Element[];
}
export default function InformationPanel({ children }: InformationPanelProps) {
  return <aside className="information-panel h-100">{children}</aside>;
}
